@if (visibleTasks().length) {
    <div class="side-panel-tasks-bar">
        <div #dropdownMenu class="dropdown" [class.show]="isDropdownOpen()">
            <div class="dropdown-toggle height-40 pl-20 pr-20" [class.active]="isDropdownOpen()"
                 (click)="toggleDropdown()">
                <div class="d-flex align-items-center mr-2">
                    <span class="text-thin">Tasks</span>
                    @if (hasInProgressTasks()) {
                        <div class="d-flex align-items-center ml-1">
                            <div class="circle-stats-rounded ml-1"
                                 [style.--csRoundedPercentage]="completionPercentage()"
                                 style="--csRoundedSize: 26px; --csRoundedStrokeWidth: 3px">
                                <svg>
                                    <defs>
                                        <linearGradient id="circleGradientTasks" x1="0%" y1="0%" x2="100%" y2="100%">
                                            <stop offset="0%" stop-color="#0273CF"></stop>
                                            <stop offset="100%" stop-color="#E5F2FC"></stop>
                                        </linearGradient>
                                    </defs>
                                    <circle class="progress" cx="13" cy="13" r="11.5"
                                            style="stroke: url(#circleGradientTasks)"></circle>
                                </svg>
                                <span>{{ inProgressTasks().length }}</span>
                            </div>
                        </div>
                    } @else {
                        <div class="d-flex align-items-center justify-content-center ml-1 border-2 border-color-green width-24 height-24 rounded-full text-green">
                            <svg ycnIcon name="icon-check" class="fill-current text-smallest"></svg>
                        </div>
                    }
                </div>
                <div class="collapse-chevron align-self-center"></div>
            </div>
            <div class="dropdown-menu dropdown-menu-fullwidth pt-0" [class.show]="isDropdownOpen()">
                <div class="panel-action min-height-base pt-0 pb-0">
                    <ul class="nav nav-tabs justify-content-start">
                        <li class="nav-item">
                            <a class="nav-link text-normal-case"
                               [class.active]="chosenTab() === 'completed'"
                               href="#"
                               (click)="changeTab('completed', $event)">Complete</a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link text-normal-case"
                               [class.active]="chosenTab() === 'in-progress'"
                               href="#"
                               (click)="changeTab('in-progress', $event)">In Progress</a>
                        </li>
                    </ul>
                </div>
                <div class="tab-content">
                    <div class="tab-pane pl-0 pr-0 active">
                        <table class="table table-hover mb-0">
                            <tbody>
                                @if (chosenTab() === 'completed') {
                                    @for (task of completedTasks(); track task.id) {
                                        <tr (click)="onTaskClicked(task, $event)">
                                            <td>
                                                <div class="text-default">{{ task.title }}</div>
                                                @if (task.completed_at) {
                                                    <span>{{ task.completed_at }}</span>
                                                }
                                            </td>
                                            <td class="pl-0 text-right">
                                                <button class="btn btn-transparent btn-lightgray btn-circle btn-xs"
                                                        (click)="onHideTask(task, $event)">
                                                    <svg ycnIcon name="icon-close"></svg>
                                                </button>
                                            </td>
                                        </tr>
                                    } @empty {
                                        <tr>
                                            <td class="text-center text-gray-30">No completed tasks</td>
                                        </tr>
                                    }
                                } @else {
                                    @for (task of inProgressTasks(); track task.id) {
                                        <tr
                                            (click)="onTaskClicked(task, $event)">
                                            <td class="max-width-150">
                                                <div class="td-ellipsis text-blue">
                                                    <span class="td-ellipsis-content">{{ task.title }}</span>
                                                </div>
                                            </td>
                                            <td class="pl-0 text-right">
                                                <button class="btn btn-transparent btn-lightgray btn-circle btn-xs"
                                                        (click)="onDeleteTask(task, $event)">
                                                    <svg ycnIcon name="icon-delete"></svg>
                                                </button>
                                            </td>
                                        </tr>
                                    }

                                    @for (task of cancelledTasks(); track task.id) {
                                        <tr class="disabled"
                                            (click)="onTaskClicked(task, $event)">
                                            <td class="max-width-150">
                                                <div class="td-ellipsis">
                                                    <span class="td-ellipsis-content">{{ task.title }}</span>
                                                </div>
                                            </td>

                                            <td class="text-right" colspan="2">
                                                <span class="mr-1">Cancelled</span>
                                                <button class="btn btn-transparent btn-lightgray btn-circle btn-xs"
                                                        (click)="onHideTask(task, $event)">
                                                    <svg ycnIcon name="icon-close"></svg>
                                                </button>
                                            </td>
                                        </tr>
                                    }
                                }
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
}
